import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getPlanListFilters = (state: IRootState) => state.planListFilter.filters;
export const getPlanListFiltersCurrent = (state: IRootState) => state.planListFilter.current;
export const getPlanListFiltersCurrentId = (state: IRootState) => state.planListFilter.currentId;
